// 面包屑导航
const RoleList = {
  // 公司负责人
  a: 'company_representative',
  // 远程审方药师
  b: 'remote_trial_pharmacist',
  remote_trial_pharmacist: 'remote_trial_pharmacist',
  // 区域负责人
  c: 'regional_head',
  // 店长
  d: 'store_manager',
  // 店员
  e: 'clerk',
  // 药师
  f: 'pharmacist',
  // 患者
  g: 'patient',
  // 省负责人，监管账号
  h: 'province_manager',
  // 市负责人，监管账号
  i: 'city_manager',
  // 区负责人，监管账号
  j: 'district_manager',
  // 第三方普通店员
  k: 'third_party_normal_employees',
  // 商城管理员
  l: 'buyers',
  // 快药管理员
  m: 'quick_medicine_manager'
};
const Constant = {
  tabItems: [
    {
      name: 'PrescriptionList',
      title: '处方列表'
    },
    {
      // name:'PrescriptionDetail',
      title: '处方详情'
    }
  ],
  pageSize: 12,
  waitPrescriptionListPageSiz: 50,
  prescriptionStatus: {
    0: '待审核',
    1: '待审核',
    2: '已完成',
    3: '已驳回',
    4: '已失效'
    // 5: '待复核'
  },
  searchStatus: {
    1: '待审核',
    2: '已完成',
    3: '已驳回',
    4: '已失效'
    // 5: '待复核'
  },
  advisoryTypes: {
    2: '图文',
    4: '视频',
    8: '拍照开方'
  },
  prescriptionType: {
    0: '西药',
    1: '中药'
  },
  printStatus: {
    0: '未打印',
    1: '已打印'
  },
  // 角色类型
  roleType: {
    remote_trial_pharmacist: '远程审方药师',
    company_representative: '公司负责人',
    regional_head: '大区负责人',
    store_manager: '店长',
    clerk: '店员',
    pharmacist: '药师',
    patient: '患者',
    buyers: '商城管理员',
    quick_medicine_manager: '快药管理员'
  },
  // 后端传输需要数据
  roleTypeObj: {
    remote_trial_pharmacist: {
      code: 'remote_trial_pharmacist',
      name: '远程审方药师'
    },
    store_manager: {
      code: 'store_manager',
      name: '店长'
    },
    clerk: {
      code: 'clerk',
      name: '店员'
    },
    pharmacist: {
      code: 'pharmacist',
      name: '审方药师'
    }
  },
  // 用户状态
  disableStatus: {
    0: '启用',
    1: '禁用'
  },
  openStatus: {
    '': '全部',
    1: '开启',
    0: '关闭'
  },
  storeStatus: {
    0: '待审核',
    '': '全部',
    1: '已审核',
    '-1': '重新认证'
  },
  punchStatus: {
    1: '启用',
    0: '禁用'
  },
  /**
 *
 * @return
 *  a: 'company_representative', // 公司负责人
    b: 'remote_trial_pharmacist', // 远程审方药师
    c: 'regional_head', // 区域负责人
    d: 'store_manager', // 店长
    e: 'clerk', // 店员
    f: 'pharmacist', // 药师
    g: 'patient', // 患者
    h: 'province_manager' // 省负责人
 */
  RoleList,
  RoleRelation: {
    company_representative: '公司负责人',
    remote_trial_pharmacist: '远程审方药师',
    regional_head: '大区负责人',
    store_manager: '店长',
    clerk: '店员',
    pharmacist: '药师',
    patient: '患者',
    province_manager: '省负责人'
  },
  openWarnPath: ['/prescription', 'shopManagement', 'staffManagement', '/waitPrescriptionList', '/messageCenter'], // 每次重新进入这些路由都会重新打开提示框和获取用户数据
  // 后端返回角色对应前端的key
  RoleKeyList: {
    company_representative: 'a',
    remote_trial_pharmacist: 'b',
    regional_head: 'c',
    store_manager: 'd',
    clerk: 'e',
    pharmacist: 'f',
    patient: 'g',
    province_manager: 'h',
    buyers: 'l',
    quick_medicine_manager: 'm'
  },
  // 职员update后端返回错误码，提示
  staffUpdateError: {
    ERROR_PHARMACIST_ROLE_STATUS_UPDATE: {
      title: '提示'
    },
    user_delete_error: {
      title: '删除职员'
    }
  },
  exportNum: 20000, // 导出最大限制
  prescriptionHandlerRule: {
    // 处方操作权限
    删除: {
      rule: [RoleList.a, RoleList.c, RoleList.d],
      status: [2, 3, 4]
    },
    下载: {
      rule: [
        RoleList.a,
        RoleList.b,
        RoleList.c,
        RoleList.d,
        RoleList.f,
        RoleList.e,
        RoleList.h,
        RoleList.i,
        RoleList.j
      ],
      status: [2]
    }
  },
  reqBizType: {
    service: '000001',
    liability: '000002',
    prescription_apply_liability: '000003'
  },
  bizType: {
    service: '100000',
    liabilityWhiteListInner: '100001',
    liabilityWhiteListOuter: '100002'
  },
  sexType: [
    {
      value: '1',
      label: '男'
    },
    {
      value: '0',
      label: '女'
    }
  ],
  serviceType: {
    '': '全部',
    1: '年费',
    2: '储值',
    3: '试用'
  }
};

// 申请类型
export const VERIFY_TYPE = {
  IDNO: '1', // 身份证申请
  CODE: '2' // 验证码申请
};

export const PATIENT_TYPE = {
  ADULT: 1, // 成人
  CHILD: 2 // 儿童
};
// advisoryType
export const CONSULT_TYPE = {
  DIRECT_CONSULT: 1,
  SIMPLE_CONSULT: 2,
  VIDEO_CONSULT: 4,
  PHOTO_CONSULT: 8
};

// 存储localstorage等storage里的key
export const STORAGE_KEY = {
  LEGAL_AGREEMENT: 'legal_argeement' // 用户协议和法律声明
};

export const HTTP_LINK = {
  // 用户服务协议
  USER_SERVICE_AGREEMENT:
    'https://static.91jkys.com/drugstore-prescription-admin-pc/template/%E6%99%BA%E4%BA%91%E9%97%AE%E8%AF%8A-%E7%94%A8%E6%88%B7%E6%9C%8D%E5%8A%A1%E5%8D%8F%E8%AE%AE20200618.html',
  // 法律声明及隐私权政策
  LEGAL_STATEMENT_AND_PRIVACY_POLICY:
    'https://static.91jkys.com/drugstore-prescription-admin-pc/template/%E6%99%BA%E4%BA%91%E9%97%AE%E8%AF%8A-%E6%B3%95%E5%BE%8B%E5%A3%B0%E6%98%8E%E5%8F%8A%E9%9A%90%E7%A7%81%E6%9D%83%E6%94%BF%E7%AD%9620200618.html'
};

export const PHOTO_TYPE = {
  TAKE: 1,
  UPLOAD: 2
};

export const photoTypeName = {
  [PHOTO_TYPE.TAKE]: '拍摄处方',
  [PHOTO_TYPE.UPLOAD]: '上传处方笺图片'
};

export const A5_W = 368;

export const A5_H = 520;

export const SERVER_STATUS = {
  NORMAL: 0,
  EXPIRE_SOON: 1,
  EXPIRED: 2
};

export const serverStatusOption = [
  {
    value: SERVER_STATUS.NORMAL,
    label: '正常'
  },
  {
    value: SERVER_STATUS.EXPIRE_SOON,
    label: '即将到期'
  },
  {
    value: SERVER_STATUS.EXPIRED,
    label: '已到期'
  }
];

export const ANNUITY_TYPE = {
  SELF_SERVICE: 500, // 自助版
  STANDARD: 999, // 标准版
  ULTIMATE: 1800, // 旗舰版
  EXCELLENT: 1799 // 优享版
};

// 连锁类型
export const CHAIN_TYPE = {
  CHAIN: 1, // 连锁
  MONOMER: 0 // 单体
};

// 交易单状态
export const TRADE_STATUS = {
  UNPAID: 0, // 未支付
  PAID: 1, // 支付成功
  FAIL: 99 // 已失效
};

// 店铺类型
export const STORE_TYPE = {
  ANNUAL_FEE: 1, // 年费
  STORED_VALUE: 2, // 储值
  TRAIL: 3, // 试用
  REGULAR: 4 // 普通，没有充值的储值
};
export const SIMPLE_CHINESE_NAME = /[\u4e00-\u9fa5·]{1,19}[\u4e00-\u9fa5]$/; // · 和 中文组成

// 订单状态
export const ORDER_STATUS = {
  INIT: 0, // 初始化状态--提交完订单，还没有点击支付
  UNPAID: 1, // 待支付--点击了支付，生成了交易单 还没付款成功
  FAIL: -1, // 订单失效
  PAID: 2, // 支付成功合同未生效
  CONTRACT_EFFECT: 3 // 合同生效
};

// 非法字符
export const INVALID_INPUT_REG =
  /[^a-zA-Z0-9\u4E00-\u9FA5\（\）\(\)\\[\]\:\：\-\。\μ\【\】\，\\\_\+\*\{\}；\,\%‘‘！\×*“”？：~./;'!"":?~\s\{\}\」\「\｛\｝]/g;

window.Constant = Constant;
export default Constant;
